import React, {useState, useMemo, useEffect, useContext} from 'react';
import styled, {css} from 'styled-components';

import Icon from 'components/icons/icon';

import theme, {bp, color} from 'settings/theme';


type Props = {
  checked: boolean,
  onChange?: (e:React.ChangeEvent<HTMLInputElement>) => void,
  children?: React.ReactNode
};

type StyledProps = {
  checked: boolean
};


// Component
const Component: React.FC<Props> = (props) => {

  return (

    <StyledComponent checked={props.checked} className="checkbox">

      <label>

        {/* Hidden Checkbox */}
        <input className="checkbox_hidden" checked={props.checked} onChange={props.onChange} type="checkbox"></input>

        {/* Styled Checkbox */}
        <div className="checkbox_styled">
          <Icon iconName="star"></Icon>
        </div>

        {/* Content */}
        <div className="checkbox_content">
          {props.children}
        </div>

      </label>

    </StyledComponent>
  
  ) ;

}


export default Component;




// Styles
const StyledComponent = styled.div<StyledProps>`

  label{
    cursor: pointer;
    display: flex;
    -webkit-tap-highlight-color: transparent;
  }

  .checkbox_hidden{
    border: 0;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

  .checkbox_styled{

    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    margin-right: 10px;
    border: solid 1px ${color.grey(70)};
    border-radius: 3px;
    transition: all 150ms;
    background-color: ${color.white};

    .icon{
      display: none;
      width: 12px;
      height: 12px;
    }

    svg path{
      fill: white;
    }

  }

  .form_checkbox_label{
    flex: 1 1 auto;
    padding-top: 4px;
    font-size: 12px;
  }


  ${props => props.checked && css`

    label{
      color: ${color.primary};
    }
    
    .checkbox_styled{

      border-color: rgba(255, 255, 255, 0);
      background-color: ${color.primary};

      .icon{
        display: flex;
      }

    }

  `}


  .checkbox_hidden:focus + .checkbox_styled {
    border: solid 1px rgba(0, 0, 0, 1);
  }


`



